/* Core & libraries */
import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import {
  SHELL_USER_COUNT_ENDPOINT,
  INVITATION_ENDPOINT,
  DELETE_SHELL_USER_ENDPOINT,
  GET_SHELL_USERS_ENDPOINT
} from "../endpoints/endpoints";
import { useNotificationContext } from "../contexts/notificationContext";
import { useUserContext } from "../contexts/userContext";
import { useGlobalContext, useGlobalUpdateContext } from "../contexts/globalContext";


/* Components */
/* Styles */

export const useAuthorizedUsersService = () => {
  const { genericApiFetch } = useGenericApiFetch();
  const [shellUserCount, setShellUserCount] = useState("")

  const { setNotification } = useNotificationContext();
  const userDetails = useUserContext();
  const globalProperties  = useGlobalContext();
  const setGlobalProperties  = useGlobalUpdateContext();
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  useEffect(() => {
    if (globalProperties?.inviteAuthorisedModal?.showInviteAuthorisedModal) {
      return
    }
    setGlobalProperties({
        ...globalProperties,
        inviteAuthorisedModal: {
          ...globalProperties.inviteAuthorisedModal,
          shellUserCount: shellUserCount,
        }
      })
  }, [shellUserCount])

  const inviteAuthorizedUsers = async (usersData) => {    
    const response = await genericApiFetch({
      url: INVITATION_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()),
      method: "POST",
      data : usersData,
      spinner: "inviteAuthorisedSpinner"
    })
    if (response.success) {
      getShellUserCount()
      setNotification(
        "success",
        <FormattedMessage id="notifications.invitation.successText" />,
      )
      return true;
    }

    setNotification(
      "error",
      <FormattedMessage id="notifications.revokeErrorTitle" />,
      <FormattedMessage id="notifications.revokeErrorText" />
    )
    return false

  };

  const deleteAuthorizedUser = async (entity) => {
    const response = await genericApiFetch({
      url: DELETE_SHELL_USER_ENDPOINT.replace("{shellUserId}", entity.shellUserId),
      method: "DELETE",
      spinner: "deleteInviteAuthorisedSpinner"
    });
    if (response.success) {
      return true;
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.removeAuthorizedUser.errorTitle" />,
      <FormattedMessage id="notifications.removeAuthorizedUser.errorDesc" />
    )
    return false;
  }

  const getShellUsers = async (companyEntityId) => {
    const response = await genericApiFetch({
      url: GET_SHELL_USERS_ENDPOINT.replace('{companyEntityId}', companyEntityId),
      method: 'GET',
    });
    if (response.success) {
      return response.data;
    }
    return false;
  };

  const getShellUserCount = async () => {
    const countResponse = await  genericApiFetch({
      url: SHELL_USER_COUNT_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "GET",
    })
    if (countResponse.success) {
      setShellUserCount(countResponse.data.shellUserCount);
    }
  };

  return {
    inviteAuthorizedUsers,
    deleteAuthorizedUser,
    shellUserCount,
    getShellUserCount,
    getShellUsers,
  };
}

